/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type V1QuizAdminPushQuizzesListState = typeof V1QuizAdminPushQuizzesListState[keyof typeof V1QuizAdminPushQuizzesListState];


export const V1QuizAdminPushQuizzesListState = {
  archived: 'archived',
  cancelled: 'cancelled',
  draft: 'draft',
  published: 'published',
  scheduled: 'scheduled',
} as const;
